module.exports = __webpack_public_path__ + "files/26af2f96dfcf2ce3a33e5c38af32d605.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-2.png
// module id = 1477
// module chunks = 60